module.exports = "/packs/step_title_sp-4669b952814348f83d7e47222bbbbd66.png";